import { createSlice } from '@reduxjs/toolkit';
import initialState from "../constants/initialState";

const Sidebar = createSlice({
    name: 'sidebar',
    initialState: initialState.sidebar,
    reducers: {
        clearState(state) {
            Object.assign(state, initialState.sidebar);
        },
        toggleSidebar(state, action) {
            state.canvas = action.payload;
        }
    }
});

export const { clearState, toggleSidebar } = Sidebar.actions;
export default Sidebar.reducer;